import React from 'react';
import AccountLayout from '../components/AccountLayout';
import WishlistSection from '../components/WishlistSection';
import { useT } from '../services/i18n';
import { usePageMeta } from '../services/seo';

const WishlistPage = () => {
  const { t } = useT();
  usePageMeta({ title: t('header.myWishlist'), noindex: true });
  const loggedIn = !!localStorage.getItem('token');
  return (
    <AccountLayout title={t('wl.title')} requireAuth={false}>
      <div data-testid="wishlist-page">
        <WishlistSection />
        {!loggedIn && (
          <p className="text-sm text-gray-500 mt-4" data-testid="wishlist-guest-hint">
            {t('wl.guestBefore')} <a href="/connexion" className="text-blue-600 hover:underline">{t('wl.guestLogin')}</a> {t('wl.guestAfter')}
          </p>
        )}
      </div>
    </AccountLayout>
  );
};

export default WishlistPage;
